import pick from "lodash/pick";
import mapValues from "lodash/mapValues";
import orderBy from "lodash/orderBy";

const getters = {
	agendaMeetingId: state => state.agendaMeetingId,
	meeting: state => state.meeting,
	meetingPermissions: state => state.meetingPermissions,
	assignedTeam: state => state.assignedTeam,
	organizer: state => state.organizer,
	invitees: state => state.invitees,

	newOutcomeField: state => topicId => {
		return state.newOutcomeFieldMap[ topicId ];
	},
	outcomeFields: state => topicId => {
		const outcomeFields = pick( state.outcomeFieldMap, state.topicOutcomeIdMap[ topicId ] );
		return mapValues( outcomeFields, outcomeField => {
			return {
				...outcomeField,
				isEditing: outcomeField.id === state.editingOutcomeId,
			};
		} );
	},
	topicFields: state => topicId => {
		return orderBy( state.topicFieldMap[ topicId ] || [], [ "order", ], [ "asc", ] );
	},
	//
	// flags
	//
	isInitializingMeetingAgendaStore: state => state.isInitializingMeetingAgendaStore,
	hasInitializedMeetingAgendaStore: state => state.hasInitializedMeetingAgendaStore,
	isSavingTopicOutcome: state => state.isSavingTopicOutcome,
	isSavingExistingTopicOutcome: state => state.isSavingExistingTopicOutcome,
	isSavingNewTopicOutcome: state => state.isSavingNewTopicOutcome,
	isDeletingExistingTopicOutcome: state => state.isDeletingExistingTopicOutcome,
	editingOutcomeId: state => state.editingOutcomeId,
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/modules/meetingAgenda/getters.js